import React from 'react';

const IndeterminateIcon = ({ width = 24, height = 24 }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" width={width} height={height}>
    <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM7 11h10v2H7z" />
  </svg>
);

export default IndeterminateIcon;
